import { memo } from "react";

import { OPERATOR_SYMBOLS } from "./constants";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

// Pre-compute operator options to avoid recalculation on every render
const OPERATOR_OPTIONS = Object.entries(OPERATOR_SYMBOLS);

const OperatorSelect = memo(
  ({
    value,
    onChange,
    readonly,
  }: {
    value: string;
    onChange: (value: string) => void;
    readonly?: boolean;
  }) => (
    <Select value={value} onValueChange={onChange} disabled={readonly}>
      <SelectTrigger className="w-[180px] focus:ring-2 focus:ring-blue-100">
        <SelectValue placeholder="Op" />
      </SelectTrigger>
      <SelectContent>
        {OPERATOR_OPTIONS.map(([key, symbol]) => (
          <SelectItem key={key} value={key}>
            {symbol}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  ),
);

export default OperatorSelect;
